module.exports = __webpack_public_path__ + "img/ctu_banner_btn.25ba67e5.png";